"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Form component
 *
 * @package HOPS
 * @subpackage Components
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */class Form extends _react.default.Component {
  /**
   * Constructor.
   *
   * @param {Object} props
   * @return {self}
   */
  constructor(props) {
    super(props);

    /**
     * `ref`
     * 
     * @type {ReactRef}
     */
    this.form = /*#__PURE__*/_react.default.createRef();

    /**
     * Method binds
     */
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  /**
   * Submitted.
   * 
   * @param {Event} e
   * @return {void}
   */
  handleSubmit(e) {
    e.preventDefault();
    this.submit();
  }

  /**
   * Submit.
   * 
   * @return {void}
   */
  submit() {
    if (this.form.current?.reportValidity && this.form.current?.reportValidity()) {
      this.props.onSubmit();
    }
  }

  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
      onSubmit: this.handleSubmit,
      ref: this.form,
      children: this.props.children
    });
  }
}
var _default = exports.default = Form;